<template>
  <div>
    <smart-duo filterOptionsUrl="/ConsentForm/DigitalSignatureConsentFormVue"></smart-duo>

    <DigitalSignatureSendModal ref="digitalSignatureSendModal" @sent="onDigitalSignatureSent" />
    <DigitalSignatureAnswersModal ref="digitalSignatureAnswersModal" />
  </div>
</template>

<script>
  import axios from '../../../services/index'
  import SmartDuo from '../Shared/SmartDuo'
  import { refreshSmartDuoData } from '../../../helpers/dataRefresher'
  import DigitalSignatureSendModal from '../../../components/digitalSignature/DigitalSignatureSendModal'
  import DigitalSignatureAnswersModal from '../../../components/digitalSignature/DigitalSignatureAnswersModal'

  export default {
    name: 'DigitalSignatureTracking',
    components: {
      SmartDuo,
      DigitalSignatureSendModal,
      DigitalSignatureAnswersModal
    },
    methods: {
      downloadDigitalSignatureForm(customerConsentFormId) {
        this.$toastr.warning(this.$t('FileDownloadStarted'));

        const url = `/consentForm/DownloadDigitalSignatureForm?customerConsentFormId=${customerConsentFormId}`;

        axios.get(url, { responseType: 'blob' })
          .then(response => {
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'DigitalSignatureForm.pdf';

            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename="([^"]+)"/);
              if (fileNameMatch && fileNameMatch.length === 2) {
                fileName = fileNameMatch[1];
              }
            }

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);

            this.$toastr.success(this.$t('FileDownloadCompleted'));
          })
          .catch(() => {
            this.$toastr.error(this.$t('Error'));
          });
      },
      viewDigitalSignatureAnswers(customerConsentFormId) {
        if (this.$refs.digitalSignatureAnswersModal) {
          this.$refs.digitalSignatureAnswersModal.open(customerConsentFormId);
        }
      },
      openDigitalSignatureModal(customerId, customerName, customerPhone, customConsentFormId, formName, customerConsentFormId, branchId) {
        if (this.$refs.digitalSignatureSendModal) {
          this.$refs.digitalSignatureSendModal.open({
            customerId: customerId,
            customerName: customerName,
            customerPhone: customerPhone,
            formName: formName,
            customConsentFormId: customConsentFormId,
            customerConsentFormId: customerConsentFormId,
            branchId: branchId || this.$store.state.Auth.currentBranchId
          });
        }
      },
      cancelDigitalSignature(digitalSignatureId) {
        if (!confirm(this.$t('CancelDigitalSignatureConfirmation') || 'Bu dijital imza talebini iptal etmek istediğinize emin misiniz?')) {
          return;
        }

        axios.post(`/api/digitalSignature/cancel/${digitalSignatureId}`)
          .then(response => {
            if (response.data) {
              this.$toastr.success(this.$t('DigitalSignatureCancelled') || this.$t('Success'));
              refreshSmartDuoData();
            } else {
              this.$toastr.error(this.$t('Error'));
            }
          })
          .catch(() => {
            this.$toastr.error(this.$t('Error'));
          });
      },
      onDigitalSignatureSent() {
        refreshSmartDuoData();
      }
    },
    mounted() {
      window.downloadDigitalSignatureForm = this.downloadDigitalSignatureForm;
      window.viewDigitalSignatureAnswers = this.viewDigitalSignatureAnswers;
      window.showDigitalSignatureAnswers = this.viewDigitalSignatureAnswers;
      window.openDigitalSignatureModal = this.openDigitalSignatureModal;
      window.cancelDigitalSignature = this.cancelDigitalSignature;
    },
    beforeDestroy() {
      delete window.downloadDigitalSignatureForm;
      delete window.viewDigitalSignatureAnswers;
      delete window.showDigitalSignatureAnswers;
      delete window.openDigitalSignatureModal;
      delete window.cancelDigitalSignature;
    }
  }
</script>
